// Ghast fireball (MOB-5 flying). PURE (ENG-1). Spawns via the EntitySystem; the
// straight-line flight + explode-on-impact runs in EntitySystem.tickFireball.
import { FIREBALL } from '../../config';
import type { Entity, EntitySystem } from '../entity';

/** Launch a fireball from `shooter` straight toward (tx,ty,tz) (M7.2). */
export function fireFireballAt(sys: EntitySystem, shooter: Entity, tx: number, ty: number, tz: number): void {
  const sx = shooter.x, sy = shooter.y + 1.5, sz = shooter.z;
  const dx = tx - sx, dy = ty - sy, dz = tz - sz;
  const len = Math.hypot(dx, dy, dz) || 1e-4;
  const s = FIREBALL.SPEED / len;
  sys.spawnProjectile('fireball', sx, sy, sz, dx * s, dy * s, dz * s, shooter.id, 0);
}
